import React from "react";
import QuizPage from "../../Quiz/QuizPage";

const SubSectionQuiz = ({ basicData }) => {
  return (
    <>
      <div className="container-fluid ">
        <QuizPage apiPath="2d/lms" basicData={basicData} />
      </div>
    </>
  );
};

export default SubSectionQuiz;
